import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Paper, Stack, Text } from '@mantine/core';
import { VipRewardItem } from './VipRewardItem';
export const VipClubReward: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack py={40} align="center">
      <Text fz={{
      base: 'sm',
      sm: 'lg'
    }} className={gunterzBold.className} c="var(--text-white)" ta="center">
        {i18n._('VIP Rewards at Every Level')}
      </Text>

      <Paper radius={5} bg="var(--bg-200)" p={{
      base: 10,
      sm: 20
    }} w={{
      base: '100%',
      lg: '90%'
    }}>
        <VipRewardItem iconUrl="/assets/vip-club/icons/percentage.svg" title={i18n._('Rakeback')} description={i18n._('Earn a percentage of the house edge back on every bet you place. Claim your rakeback every hour and boost your balance instantly.')} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/stats.svg" title={i18n._('Rank-Up Bonuses')} description={i18n._('Each time you level up, you’ll get a special bonus based on your gameplay and progress since your last rank. Bigger ranks mean bigger rewards!')} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/cat.svg" title={i18n._('PrimeOrb Roulette')} description={i18n._('Level up and get up to three spins on the PrimeOrb Trait Roulette. Spin for a chance to unlock exclusive PrimeOrb items—maybe even a legendary item!')} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/money-bag.svg" title={i18n._('Daily, Weekly, and Monthly Bonuses')} description={i18n._('The higher your VIP level, the better your bonuses! Claim daily, weekly, and monthly bonuses based on your recent activity and gameplay.')} />

        <VipRewardItem iconUrl="/assets/vip-club/icons/reload.svg" title={i18n._('Reload Bonuses (Platinum and Above)')} description={i18n._(`If you're having a rough streak, we’ve got your back. Get reload bonuses to help you bounce back and keep the fun going.`)} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/swords.svg" title={i18n._('Exclusive Battles')} description={i18n._('Reach Rhodium and higher to join sponsored battles with big prizes. The higher your level, the bigger the stakes!')} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/vip-crown.svg" title={i18n._('VIP Host (Rhodium and Above)')} description={i18n._('Once you hit Rhodium, you’ll get a personal VIP host to guide you, handle your requests, and offer you special deals.')} />
        <VipRewardItem iconUrl="/assets/vip-club/icons/preferences.svg" title={i18n._('Customized Benefits (Diamond and Above)')} description={i18n._('Starting from Diamond, your VIP host can tailor your rewards and offers based on your play style. Get ready for a personalized experience!')} />
      </Paper>
    </Stack>;
};